export default {
  methods: {
    changeSort({ prop, order }) {
      const sort = order ? prop : null
      const sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : null
      this.sort = sort
      this.order = sortOrder
      this.getData({ ...this.params, sort, order: sortOrder })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size) // 设置常用页码
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    searchFilterData(params) {
      this.pageIndex = 1
      const sortObj = {}
      if (this.sort) {
        sortObj.sort = this.sort
      }
      if (this.order) {
        sortObj.order = this.order
      }
      this.getData({ ...params, ...sortObj })
    },
    resultOk() {
      this.resultModel = false
      this.pageIndex = 1
      this.getData()
    }
  },
  data() {
    return {
      sort: null,
      order: null,
      loading: null,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      tableList: [],
      resultModel: false,
      summaryData: {}
    }
  }
}
